import { IrisQueryParamsBuilder } from '@iris/api-query';
import { IrisContact } from '@iris/common/models/IrisContact';
import { IrisContactsService } from '@iris/common/services/contacts.service';
import { IrisFilterDefaultChipItemViewComponent } from '@iris/modules/module-filters-v2/chips/default-chip-item-view.component';
import { isObject } from 'lodash';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { IrisFilterChipRenderingOptions } from './chip-rendering-options';
import { ComponentRef } from '@angular/core';

type Contact = IrisContact | IrisContact['id'];

export const CONTACT_CHIP_RENDERING_OPTIONS: IrisFilterChipRenderingOptions<IrisFilterDefaultChipItemViewComponent, Contact> = {
  component: IrisFilterDefaultChipItemViewComponent,
  initComponentFn: (componentRef: ComponentRef<IrisFilterDefaultChipItemViewComponent>, contact, injector) => {
    const component = componentRef.instance;
    const service = injector.get(IrisContactsService);
    const id = isObject(contact) ? contact.id : contact;
    const params = new IrisQueryParamsBuilder().onlyFields(['fullName']).toStructure();

    component.text$ = service.get(id, params)
      .pipe(
        map(entity => entity.fullName),
        publishReplay(1),
        refCount(),
      );
  },
};
